import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import oersData from './open-educational-resources.json';
import GoogleAnalytics from '../../analyticsComponents/GoogleAnalytics.js';

function OtherOERsPage() {
    const [resources, setResources] = useState([]);

    useEffect(() => {
        setResources(oersData); // could fetch from API in future
    }, []);

    return (
        <>
            <Helmet>
                <title>Other Useful Open Educational Resources - Share2Teach</title>
                <meta name="description" content="Explore additional open educational resources (OERs) provided by Share2Teach, supporting learners and educators at NWU and NWU Enterprises." />
                <meta name="keywords" content="Open Educational Resources, OER, NWU, NWU Enterprises, free educational resources, Share2Teach OERs" />
                <meta property="og:title" content="Other Useful Open Educational Resources - Share2Teach" />
                <meta property="og:description" content="Explore additional open educational resources (OERs) provided by Share2Teach, supporting learners and educators at NWU and NWU Enterprises." />
                <meta property="og:type" content="website" />
            </Helmet>

            <GoogleAnalytics page="OtherOERPage" eventType="otherOERPage" />

            {/* Header */}
            <div className="max-w-6xl mx-auto px-5 mt-6">
                <div className="flex items-center gap-3">
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">Discover</span>
                    <h1 className="text-2xl font-bold text-gray-900">Other Useful OERs</h1>
                </div>
                <p className="mt-1 text-sm text-gray-500">A selection of quality open educational resources to support your teaching and learning.</p>
            </div>

            <div className="max-w-6xl mx-auto px-5 py-10">
                <div className="space-y-8">
                    {resources.map((oer, index) => (
                        <section key={index} className="bg-white rounded-xl shadow p-6 border border-gray-100">
                            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 text-center">{oer.title}</h2>
                            <p className="text-center text-gray-600 mt-1">{oer.subtitle}</p>
                            <div className="flex justify-center">
                                <img src={oer.image} alt={oer.subtitle} className="mx-auto my-6 w-full max-w-xs h-auto rounded shadow-md" />
                            </div>
                            <div className="prose prose-sm max-w-none text-gray-700">
                                {oer.description.map((para, i) => (
                                    <p key={i} className="leading-relaxed">{para}</p>
                                ))}
                            </div>
                            <h4 className="text-center text-lg font-semibold mt-6 mb-3">{oer.resourceHeading}:</h4>
                            <div className="text-center">
                                <a href={oer.resourceLink} target="_blank" rel="noopener noreferrer" className="inline-block group">
                                    <img
                                        src={oer.resourceImage}
                                        alt={oer.resourceImageAlt}
                                        className="mx-auto w-full max-w-xs h-auto rounded shadow-md group-hover:shadow-lg transition"
                                    />
                                </a>
                            </div>
                        </section>
                    ))}
                </div>
            </div>
        </>
    );
}

export default OtherOERsPage;
